import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import PageTitle from '../../components/pageTitle';
import { getLanguageFontWithFallback } from '../../utils/fontUtils';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'zh';

  // 云朵背景图路径
  const cloudBgUrl = `${process.env.PUBLIC_URL}/image/云朵背景.jpg`;

  return (
    <div className="privacy-policy-container">
      <div 
        className="privacy-policy-cloud-bg"
        style={{
          backgroundImage: `url(${cloudBgUrl})`
        }}
      />
      <div className="privacy-policy-section-container">
        <PageTitle marginBottom="53px">
          <span style={{ fontFamily: getLanguageFontWithFallback(currentLang) }}>{t('footer.privacy')}</span>
        </PageTitle>
        <div className="privacy-policy-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{t('privacyPolicy.content')}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

